import { handleActions } from 'redux-actions';

import * as types from './actionTypes';

export const initialState = {
	sort: ['campaignName,asc', 'id,desc'],
	currentCampaigns: [],
	planedCampaigns: [],
};

const reducerMap = {
	[types.SET_CAMPAIGNS]: (state, { payload }) => {
		const { type, campaigns } = payload;
		return {
			...state,
			[type]: campaigns,
		};
	},
	[types.APPEND_CAMPAIGNS]: (state, { payload }) => {
		const { type, campaigns } = payload;
		return {
			...state,
			[type]: state[type].concat(campaigns),
		};
	},
	[types.SET_SORT]: (state, { payload }) => {
		return {
			...state,
			sort: payload.sort,
		};
	},
	[types.RESET]: () => initialState,
};

export default handleActions(reducerMap, initialState);
